export enum SlideType {
  video = 0,
  image = 1,
  discussion = 2,
  interactiveQuiz = 3,
  interactivePoll = 4,
  soloQuiz = 5,
  professorFeedback = 6,
  processingData = 7,
  sessionResults = 8,
  exhibitGrid = 9,
  groupQuiz = 10,

  grading = 11,
  endOfSession = 12,
  sortedSoloInput = 13,
  sortedGroupInput = 14,
  sortedGroupInteractive = 15,
  iframe = 16,
  animatedCards = 17,
  markdown = 18,
  learningObjectives = 19,
  interactiveForm = 20,
  sharedGoogleDoc = 21,
  waitingRoom = 22,
  dynamicIntroVideo = 23,
  /**
   * Demo-only: triggers a partial grading run for rubrics fully contained
   * before this slide, while transcription continues. The official
   * processingData slide later scores the remaining rubrics.
   */
  partialProcessingData = 24,
}

/**
 * True for both processing slide variants (official `processingData` and the
 * demo-only `partialProcessingData`). Use for shared presentation behavior
 * (processing media/asset config). Do NOT use where "end of experience"
 * semantics are intended — only the official `processingData` slide ends the
 * experience.
 */
export function isProcessingSlideType(type: SlideType | undefined): boolean {
  return (
    type === SlideType.processingData ||
    type === SlideType.partialProcessingData
  )
}

export enum ExhibitGridDisplayMode {
  all = 0,
  upToNow = 1,
  currentSlide = 2,
}

export class UnsupportedMediaTypeError extends Error {
  name = 'UnsupportedMediaTypeError'
}
